import gql from 'graphql-tag';

export default gql`
    query GetStageSummary($jobId: Int) {
        getStageSummary(jobId: $jobId) {
            wellhead
            preparing
            running
            paused
            completed
            remaining
        }
    }
`;
